import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=0e397c81&scoped=true"
import script from "./Return.vue?vue&type=script&lang=js"
export * from "./Return.vue?vue&type=script&lang=js"
import style0 from "./Return.vue?vue&type=style&index=0&id=0e397c81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e397c81",
  null
  
)

export default component.exports